module.exports = __webpack_public_path__ + "img/playtest2.3d59ce60.jpg";